import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "c-sitelogin" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "header-content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "complete"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import { ref, watch } from 'vue';
import Login from './login/Login.vue';
import Reset from './login/Reset.vue';
import SlideInObject from './objects/SlideInObject.vue';

import AccountIcon from '@web/assets/icon/user.svg';

import { useSiteStore } from '../stores/siteStore';
import { useGlobalStore } from '../stores/globalStore';

export default /*@__PURE__*/_defineComponent({
  __name: 'SiteLogin',
  setup(__props) {

const siteStore = useSiteStore();

const globalStore = useGlobalStore();

const version = ref('complete');

const isOpen = ref(false);

watch(
  () => globalStore.login,
  () => {
    toggleSlideIn();
  }
);

function handleButton() {
  if (siteStore.account.isLoggedIn) {
    window.location.href = '/account';
    return;
  }

  toggleSlideIn();
}

function toggleSlideIn() {
  version.value = 'login';
  isOpen.value = !isOpen.value;
}

function changeVersion(change: string) {
  version.value = change;
}

function switchVersion() {
  if (version.value !== 'login') {
    version.value = 'login';
    return;
  }

  version.value = 'reset';
}

function isVersion(value: string) {
  if (version.value == value) {
    return true;
  }

  return false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", {
      class: "c-sitelogin__button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleButton()))
    }, [
      _createVNode(_unref(AccountIcon)),
      (_unref(siteStore).account.isLoggedIn)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Konto"))
        : (_openBlock(), _createElementBlock("p", _hoisted_3, "Login"))
    ]),
    _createVNode(SlideInObject, {
      "is-open": isOpen.value,
      "aria-label": "Site Login",
      onClose: _cache[4] || (_cache[4] = ($event: any) => (toggleSlideIn()))
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (isVersion('login'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Log ind"))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, "Nulstil adgangskode"))
        ])
      ]),
      body: _withCtx(() => [
        (isVersion('login'))
          ? (_openBlock(), _createBlock(Login, {
              key: 0,
              onSuccess: _cache[1] || (_cache[1] = ($event: any) => (toggleSlideIn()))
            }))
          : _createCommentVNode("", true),
        (isVersion('reset'))
          ? (_openBlock(), _createBlock(Reset, {
              key: 1,
              onSuccess: _cache[2] || (_cache[2] = ($event: any) => (changeVersion('complete')))
            }))
          : _createCommentVNode("", true),
        (isVersion('complete'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[5] || (_cache[5] = [
              _createElementVNode("span", null, " Hvis der findes en konto med det givne email, modtager du snart en e-mail med et nulstillings-link. ", -1)
            ])))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["switch", { 'switch--button': isVersion('complete') }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (switchVersion()))
        }, [
          (isVersion('login'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Glemt adgangskode?"))
            : _createCommentVNode("", true),
          (isVersion('reset') || isVersion('complete'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Log ind"))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      footer: _withCtx(() => _cache[6] || (_cache[6] = [])),
      _: 1
    }, 8, ["is-open"])
  ]))
}
}

})